import React, { useState } from 'react';
import Navbar from '../../../Components/Navbar';
import { toast } from 'react-toastify';
import { Create_Api } from '../../../API/Api_Url';
import { useNavigate, useParams } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

function ContractorLogin() {
    const navigate = useNavigate()
    const [IsUploading, setIsUploading] = useState(false);
    const [Email, setEmail] = useState('');
    const [password, setpassword] = useState('');
    const [ShowPassword, setShowPassword] = useState(false);


    const [errors, setErrors] = useState({});
    const validateForm = () => {
        const newErrors = {};
        if (!Email) newErrors.Email = 'Email or Phone Number is required.';

        if (!password) newErrors.password = 'Password is required.';
        else if (password.length < 6)
            newErrors.password = 'Password must be at least 6 characters long.';

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const handleLogin = async () => {
        try {
            if (validateForm()) {

                const data = {
                    email: Email,
                    password
                };

                setIsUploading(true);
                const response = await Create_Api(`api/contractor/login`, data);
                console.log('Login Successful:', response?.data);
                localStorage.removeItem("UserType");
                localStorage.removeItem("user");
                localStorage.removeItem("userToken");
                localStorage.setItem('UserType', 'contractor');
                localStorage.setItem('user', JSON.stringify(response?.data?.contractor));
                localStorage.setItem('userToken', response?.data?.tokens?.accessToken);
                toast.success(response?.message);
                setEmail('');
                setpassword('');
                navigate('/');
                setTimeout(() => window.location.reload(), 3000);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
            console.error(error);
        } finally {
            setIsUploading(false);
        }
    };



    return (
        <>
            <Navbar />
            <div className="signup-container">
                <div className="signup-form">
                    <h3 className="signup-title">Login As Contractor</h3>
                    <p className="signup-subtitle">
                        Welcome back! Please enter your credentials to continue
                    </p>

                    <label className="signup-label">Email or Phone Number</label>
                    <input
                        name="email"
                        value={Email}
                        onChange={(e) => { setEmail(e.target.value) }}
                        className="signup-input"
                    />
                    {errors?.Email && <span className="error-text">{errors?.Email}</span>}
                    <label className="signup-label">Password</label>
                    <div style={{ position: 'relative' }}>
                        <input
                            type={ShowPassword ? 'text' : 'password'}
                            name="password"
                            value={password}
                            onChange={(e) => setpassword(e.target.value)}
                            className="signup-input"
                        />
                        <button
                            type="button"
                            onClick={() => setShowPassword(!ShowPassword)}
                            style={{
                                position: 'absolute',
                                right: 10,
                                top: '50%',
                                transform: 'translateY(-50%)',
                                background: 'transparent',
                                border: 'none',
                                cursor: 'pointer'
                            }}
                        >
                            {ShowPassword ? <FaEyeSlash /> : <FaEye />}
                        </button>
                    </div>
                    {errors?.password && <span className="error-text">{errors?.password}</span>}
                    <div className="forgot-password">
                        <button
                            type="button"
                            className="forgot-password-btn"
                            onClick={() => navigate("/ph-forgotpassword")}
                        >
                            Forgot Password?
                        </button>
                    </div>
                    <button
                        onClick={() => { handleLogin() }}
                        className="signup-button"
                        disabled={IsUploading}
                    >
                        {IsUploading ? (
                            <span className="loader"></span>
                        ) : (
                            'Login'
                        )}
                    </button>
                    <div className="account-exists">
                        <p>
                            Don’t have an account?{" "}
                            <button
                                className="account-exists-btn"
                                onClick={() => navigate("/ph-ContractorSignUp")}
                            >
                                Sign Up
                            </button>
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ContractorLogin;
